import React, { useState } from 'react';
import { Button, Popover } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { StyledEventName, StyledEventWrapper, Div, Wrapper } from './styled';
import { ParaHeader, Title } from '@src/components/metrics-panel-hz/MetricCard/Tools/Help/styled';
import { getFlowType } from './utils';

function renderEvents(events: Array<{ id: number; name: string }> | { id: number; name: string }) {
  const mappedEvents = !Array.isArray(events) ? [events] : events;

  return mappedEvents.map((event) => <Div key={event.id}>{event.name}</Div>);
}

const EventsTooltip = ({ currentFlow }: { currentFlow: Record<string, any> }) => {
  const { start_event, success_event, error_event } = currentFlow?.definition?.events || {};
  const { description } = currentFlow;

  return (
    <Popover
      title={
        <ParaHeader>
          <Title>{currentFlow.name}</Title>
        </ParaHeader>
      }
      content={
        <Wrapper>
          {description && <Div style={{ paddingBottom: '10px' }}>{description}</Div>}
          {start_event && (
            <StyledEventWrapper>
              <StyledEventName>Initial Event:</StyledEventName>
              <div>{renderEvents(start_event)}</div>
            </StyledEventWrapper>
          )}
          {success_event && (
            <StyledEventWrapper>
              <StyledEventName>Complete Event:</StyledEventName>
              <div>{renderEvents(success_event)}</div>
            </StyledEventWrapper>
          )}
          {error_event && (
            <StyledEventWrapper>
              <StyledEventName>Error Event:</StyledEventName>
              <div>{renderEvents(error_event)}</div>
            </StyledEventWrapper>
          )}
          <Div style={{ paddingTop: '10px' }}>
            For more details, see{' '}
            <a
              href={`/app/activation/metric-builder/${getFlowType(currentFlow)}/${currentFlow.id}`}
              target={'_blank'}
              rel="noreferrer"
            >
              {currentFlow.name}
            </a>
          </Div>
        </Wrapper>
      }
      trigger="click"
    >
      <Button icon={<InfoCircleOutlined />} type="text" />
    </Popover>
  );
};

export default EventsTooltip;
